import React from "react";
import { ArrowUpRight } from "lucide-react";

interface ProjectRowProps {
  title: string;
  description: string;
  tags: string[];
  demoUrl: string;
  index: number;
}

export const ProjectRow: React.FC<ProjectRowProps> = ({
  title,
  description,
  tags,
  demoUrl,
  index,
}) => {
  const num = String(index + 1).padStart(2, "0");

  return (
    <a
      href={demoUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 md:py-14 border-t border-border transition-colors duration-300 hover:bg-surface/30"
    >
      {/* Index + Title */}
      <div className="md:col-span-5 flex items-start gap-3 md:gap-4 min-w-0">
        <span className="text-muted-foreground font-mono text-sm mt-1 shrink-0">{num}</span>
        <div className="min-w-0">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300 break-words">
            {title}
          </h3>
        </div>
      </div>

      {/* Description */}
      <div className="md:col-span-4 min-w-0">
        <p className="text-muted-foreground leading-relaxed text-pretty text-sm sm:text-base">{description}</p>
      </div>

      {/* Tags + Link */}
      <div className="md:col-span-3 flex flex-col items-start md:items-end gap-3 min-w-0">
        <div className="flex flex-wrap gap-2 md:justify-end">
          {tags.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] sm:text-xs font-medium bg-surface text-muted-foreground border border-border whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <span className="inline-flex items-center gap-1 text-sm font-medium text-foreground group-hover:text-primary transition-colors duration-300">
          Lihat Demo <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </a>
  );
};
